import schedules from './schedules'
import jobs from './jobs'
import vehicles from './vehicles'

export default {
  schedules,
  jobs,
  vehicles
}
